import React from "react";
import { ListChecks, Clock, CheckCircle2, AlertOctagon } from "lucide-react";
import { TID } from "@/lib/testIds";
import { Skeleton } from "@/components/ui/skeleton";

function Card({ label, value, icon: Icon, accent, testId, loading }) {
  return (
    <div
      className="ab-card ab-shadow-sm px-4 py-3.5 flex items-center gap-3"
      data-testid={testId}
    >
      <div
        className="h-9 w-9 rounded-lg flex items-center justify-center shrink-0"
        style={{ background: accent.bg, color: accent.fg }}
      >
        <Icon className="h-4 w-4" strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-wider text-[#64748B] font-medium">
          {label}
        </div>
        <div className="text-xl font-semibold text-[#0F172A] leading-tight mt-0.5 tabular-nums">
          {loading ? <Skeleton className="h-6 w-10" /> : value}
        </div>
      </div>
    </div>
  );
}

export default function KPICards({ kpis, loading }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      <Card
        label="Total Tasks"
        value={kpis.total}
        icon={ListChecks}
        accent={{ bg: "#F1F5F9", fg: "#0F172A" }}
        testId={TID.kpiTotal}
        loading={loading}
      />
      <Card
        label="Pending"
        value={kpis.pending}
        icon={Clock}
        accent={{ bg: "#FEF3C7", fg: "#92400E" }}
        testId={TID.kpiPending}
        loading={loading}
      />
      <Card
        label="Completed"
        value={kpis.completed}
        icon={CheckCircle2}
        accent={{ bg: "#DCFCE7", fg: "#166534" }}
        testId={TID.kpiCompleted}
        loading={loading}
      />
      <Card
        label="Overdue"
        value={kpis.overdue}
        icon={AlertOctagon}
        accent={{ bg: "#FEE2E2", fg: "#991B1B" }}
        testId={TID.kpiOverdue}
        loading={loading}
      />
    </div>
  );
}
